// The two feature tests Foundation 5 reads from Modernizr, made as Modernizr 3.6 made them. (Newer Modernizr counts
// any browser with the TouchEvent API as touch, which includes every desktop Chrome, and Foundation would then make
// its menus and tooltips work by tapping instead of hovering.)
const touch = 'ontouchstart' in window || !!(window.DocumentTouch && document instanceof window.DocumentTouch)

window.Modernizr = { touch: touch, touchevents: touch, csstransitions: true }
